import React, { useState } from 'react';
import { usePageSEO } from '../hooks/usePageSEO';
import { buildContactFormMessage, openWhatsApp } from '../config/whatsapp';
import './Contact.css';

const Contact = () => {
  usePageSEO(
    'Contact Us | Get Quote for App & Software Development - GoToBusiness',
    'Get a free quote for mobile app development, website development or software development. Contact GoToBusiness Noida. Discuss your project and get a consultation.'
  );

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    projectDescription: '',
    timeSlot: '',
    projectType: ''
  });

  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const resetForm = () => {
    setFormData({
      name: '',
      email: '',
      phone: '',
      projectDescription: '',
      timeSlot: '',
      projectType: '',
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const message = buildContactFormMessage(formData);
    openWhatsApp(message);
    setIsSubmitted(true);
    resetForm();
    setTimeout(() => setIsSubmitted(false), 5000);
  };

  const timeSlots = [
    '9:00 AM - 10:00 AM',
    '10:00 AM - 11:00 AM',
    '11:00 AM - 12:00 PM',
    '2:00 PM - 3:00 PM',
    '3:00 PM - 4:00 PM',
    '4:00 PM - 5:00 PM'
  ];

  const projectTypes = [
    'Website Development',
    'Mobile Application',
    'Software Solution',
    'Unity Gaming',
    'E-commerce Platform',
    'Other'
  ];

  return (
    <div className="contact">
      {/* Hero Section */}
      <section className="contact-hero">
        <div className="container">
          <h1>Get In Touch</h1>
          <p>Let's discuss your project and bring your ideas to life</p>
        </div>
      </section>

      {/* Contact Content */}
      <section className="contact-content section">
        <div className="container">
          <div className="contact-grid">
            {/* Contact Information */}
            <div className="contact-info">
              <h2>Contact Information</h2>
              <p>Ready to start your project? Get in touch with us today!</p>
              
              <div className="contact-details">
                <div className="contact-item">
                  <div className="contact-icon">📧</div>
                  <div>
                    <h4>Email</h4>
                    <p>rohitgupta17503@gmail.com</p>
                  </div>
                </div>
                
                <div className="contact-item">
                  <div className="contact-icon">📞</div>
                  <div>
                    <h4>Phone</h4>
                    <p>+91-8650960313</p>
                  </div>
                </div>
                
                <div className="contact-item">
                  <div className="contact-icon">📍</div>
                  <div>
                    <h4>Address</h4>
                    <p>Flat UG10 Best Homes6<br />Gali no 4 Sector 73 sarfabad<br />Noida, Gautam Buddha Nagar 201301</p>
                  </div>
                </div>
                
                <div className="contact-item">
                  <div className="contact-icon">🕒</div>
                  <div>
                    <h4>Business Hours</h4>
                    <p>Monday - Friday: 9:00 AM - 6:00 PM<br />Saturday: 10:00 AM - 4:00 PM</p>
                  </div>
                </div>
              </div>

              <div className="social-links">
                <div className="follow-us-header">
                  <h4 className="follow-us-title">follow us</h4>
                  <p className="follow-us-subtitle">ON SOCIAL MEDIA</p>
                </div>
                <div className="social-icons-vertical">
                  <div className="social-item">
                    <div className="social-icon facebook-icon">
                      <i className="fab fa-facebook-f"></i>
                    </div>
                    <span className="social-username">instantinvitation</span>
                  </div>
                  <div className="social-item">
                    <a href="https://www.instagram.com/_rohit_gupta73?igsh=MW9vcDBvZzFjdXV4Ng%3D%3D" target="_blank" rel="noopener noreferrer" className="social-link-item">
                      <div className="social-icon instagram-icon">
                        <i className="fab fa-instagram"></i>
                      </div>
                      <span className="social-username">_rohit_gupta73</span>
                    </a>
                  </div>
                  <div className="social-item">
                    <a href="https://www.linkedin.com/in/rohit-gupta2017/" target="_blank" rel="noopener noreferrer" className="social-link-item">
                      <div className="social-icon linkedin-icon">
                        <i className="fab fa-linkedin-in"></i>
                      </div>
                      <span className="social-username">rohit-gupta2017</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="contact-form-container">
              <h2>Project Discussion Form</h2>
              <p>Fill out the form below and we'll get back to you within 24 hours</p>
              
              {isSubmitted ? (
                <div className="success-message">
                  <div className="success-icon">✅</div>
                  <h3>Thank You!</h3>
                  <p>
                    WhatsApp opened with your details. Tap Send in WhatsApp to deliver the
                    message — we will get back to you soon!
                  </p>
                </div>
              ) : (
                <form className="contact-form" onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label htmlFor="name">Full Name *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      placeholder="Enter your full name"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="email">Email Address *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      placeholder="Enter your email address"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="phone">Phone Number *</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                      placeholder="Enter your phone number"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="projectType">Project Type *</label>
                    <select
                      id="projectType"
                      name="projectType"
                      value={formData.projectType}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select project type</option>
                      {projectTypes.map((type, index) => (
                        <option key={index} value={type}>{type}</option>
                      ))}
                    </select>
                  </div>

                  <div className="form-group">
                    <label htmlFor="projectDescription">Project Description *</label>
                    <textarea
                      id="projectDescription"
                      name="projectDescription"
                      value={formData.projectDescription}
                      onChange={handleChange}
                      required
                      rows="5"
                      placeholder="Describe your project requirements, goals, and any specific features you need..."
                    ></textarea>
                  </div>

                  <div className="form-group">
                    <label htmlFor="timeSlot">Preferred Discussion Time *</label>
                    <select
                      id="timeSlot"
                      name="timeSlot"
                      value={formData.timeSlot}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select preferred time slot</option>
                      {timeSlots.map((slot, index) => (
                        <option key={index} value={slot}>{slot}</option>
                      ))}
                    </select>
                  </div>

                  <button type="submit" className="btn submit-btn">
                    Send Message
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Contact;